<template>
    <el-dialog v-model="dialogVisible" title="施工详情" width="800px">
        <template #default>
            <el-descriptions :title="'施工单号： ' + resData.orderNo" direction="vertical" :column="4" border>
                <el-descriptions-item label="工单进度">{{ jinduFormData(resData.state) }}</el-descriptions-item>
                <!-- <el-descriptions-item label="动火许可证审核">18100000000</el-descriptions-item>
                <el-descriptions-item label="高处作业许可证审核">18100000000</el-descriptions-item> -->
                <el-descriptions-item label="施工单号" :span="2">{{ resData.orderNo }}</el-descriptions-item>
                <el-descriptions-item label="申请时间">{{ resData.createTime }}</el-descriptions-item>
                <el-descriptions-item label="工作名称">{{ resData.workName }}</el-descriptions-item>
                <!-- <el-descriptions-item label="完成维修">18100000000</el-descriptions-item> -->
                <el-descriptions-item label="承包商全称">{{ resData.contractorName }}</el-descriptions-item>
                <el-descriptions-item label="承包商负责人">{{ resData.contractorUser }}</el-descriptions-item>
                <el-descriptions-item label="负责人手机号">{{ resData.contractorPhone }}</el-descriptions-item>
                <el-descriptions-item label="作业工人名单">{{ resData.maintenanceUser }}</el-descriptions-item>
                <el-descriptions-item label="接口部门">{{ resData.refDepartName }}</el-descriptions-item>
                <el-descriptions-item label="接口人员">{{ resData.refDepartUserName }}</el-descriptions-item>
                <el-descriptions-item label="接口人员职务">{{ resData.userPosition }}</el-descriptions-item>
                <el-descriptions-item label="接口人员电话">{{ resData.userMobile }}</el-descriptions-item>
                <el-descriptions-item label="接口人员手机">{{ resData.userPhone }}</el-descriptions-item>
                <el-descriptions-item label="许可证有效期">{{ resData.licenseStartTime }} {{ resData.licenseStartHour }}至
                    {{ resData.licenseEndTime }} {{ resData.licenseEndHour }}</el-descriptions-item>
                <el-descriptions-item label="承包商类型">{{ resData.contractorLongTerm == 1 ? '长期（工作时间超过七天）' :
                    '短期（工作时间不超过七天）' }}</el-descriptions-item>
                <el-descriptions-item label="承包商人数">{{ resData.contractorNum }}</el-descriptions-item>
                <!-- <el-descriptions-item label="特种作业人员">{{ resData.userPhone }}</el-descriptions-item>
                <el-descriptions-item label="相关附件">{{ resData.userPhone }}</el-descriptions-item> -->
                <el-descriptions-item label="有关承包商安全管理的所有手续文件是否均已接收">{{ (resData.doAcceptIt == 1) ? '是' :
                    '否' }}</el-descriptions-item>
                <el-descriptions-item label="工作区域">{{ resData.refAreaName }}</el-descriptions-item>
                <el-descriptions-item label="工作备注">{{ resData.wordContext }}</el-descriptions-item>
                <el-descriptions-item label="作业说明与分析">{{ resData.wordDescribeContext }}</el-descriptions-item>
                <el-descriptions-item label="工具/物料/车辆所有物品是否设置明显的承包商标志">{{ (resData.contractorSign == 1) ? '是' :
                    '否' }}</el-descriptions-item>
                <el-descriptions-item label="工具清单">{{ resData.toolListContext }}</el-descriptions-item>
                <el-descriptions-item label="材料/物料清单">{{ resData.mbomContext }}</el-descriptions-item>
                <el-descriptions-item label="车辆清单">{{ resData.carCotext }}</el-descriptions-item>
                <el-descriptions-item label="人体任何部位需要置于设备里或设备附近危险区域?">{{ (resData.personnelDanger == 1) ? '是' :
                    '否' }}</el-descriptions-item>
                <el-descriptions-item label="潜在危害因素选择">
                    <el-button type="primary" @click="selectDictDataUserListFun(1)" link
                        v-if="resData.potentialChoose">已选择</el-button>
                    <text v-else>未选择</text>
                </el-descriptions-item>
                <el-descriptions-item label="安全对策选择">
                    <el-button type="primary" @click="selectDictDataUserListFun(2)" link
                        v-if="resData.measuresChoose">已选择</el-button>
                    <text v-else>未选择</text>
                </el-descriptions-item>
                <el-descriptions-item label="个人防护用品选择">
                    <el-button type="primary" @click="selectDictDataUserListFun(3)" link
                        v-if="resData.protectionChoose">已选择</el-button>
                    <text v-else>未选择</text>
                </el-descriptions-item>
                <el-descriptions-item label="特种作业人员选择"><el-button type="primary" @click="selectDictDataUserListFun(4)"
                        link>已选择</el-button></el-descriptions-item>
            </el-descriptions>
            <el-dialog v-model="innerVisible" width="700px" title="潜在危害因素选择" append-to-body>
                <template #default>
                    <el-table :data="gridData" max-height="550">
                        <el-table-column label="序号" type="index" width="80">
                        </el-table-column>
                        <el-table-column property="dictLabel" label="名称" width="200" />
                        <el-table-column property="checked" label="是否选择">
                            <template #default="scope">
                                <el-checkbox v-model="scope.row.checked" />
                            </template>
                        </el-table-column>

                    </el-table>
                </template>
            </el-dialog>
            <el-dialog v-model="SpecialInnerVisible"  width="800px" title="特种作业人员选择"
                append-to-body>
                <template #default>
                    <el-table :data="specialGridData" :span-method="objectSpanMethod" max-height="550">
                        <el-table-column property="dictLabel" label="名称" width="200" />
                        <el-table-column property="name" label="工种" width="200" />
                        <el-table-column property="num" label="人数" width="200" />
                        <el-table-column property="checked" label="是否选择">
                            <template #default="scope">
                                <el-checkbox v-model="scope.row.checked" />
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-descriptions title="附件" direction="vertical" :column="2" border>
                        <el-descriptions-item label="附件">

                            <el-image v-for="(src, index) in srcList"
                                style="width: 100px; height: 100px;margin-right: 5px;" :src="src" :zoom-rate="1.2"
                                :max-scale="7" :min-scale="0.2" :preview-src-list="srcList" show-progress
                                :initial-index="index" fit="cover" />
                        </el-descriptions-item>
                    </el-descriptions>
                </template>
            </el-dialog>
        </template>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogVisible = false">关闭</el-button>
            </span>
        </template>
    </el-dialog>

</template>
<script setup>
import { ref, onMounted } from 'vue';
import { getOrderOneInfo, selectDictDataUserList, getOrderOneInfoByMaintenanceNew } from '@/api/index';

const dialogVisible = ref(false);
const innerVisible = ref(false);
const SpecialInnerVisible = ref(false);
const srcList = ref([])
const gridData = ref([])
const specialGridData = ref([
    { dictLabel: '电工', name: '高压', key: 'tallSelected', numKey: 'tallNm', num: '' },
    { dictLabel: '电工', name: '低压', key: 'supportSelected', numKey: 'supportNum', num: '' },
    { dictLabel: '金属焊接切割', name: '金属焊接切割', key: 'slicingSelected', numKey: 'slicingNum', num: '' },
    { dictLabel: '起重作业', name: '司机', key: 'driverSelected', numKey: 'driverNum', num: '' },
    { dictLabel: '起重作业', name: '司索', key: 'slingSelected', numKey: 'slingNum', num: '' },
    { dictLabel: '起重作业', name: '指挥', key: 'commandSelected', numKey: 'commandNum', num: '' },
    { dictLabel: '场内机动车驾驶', name: '叉车', key: 'forkliftSelected', numKey: 'forkliftNum', num: '' },
    { dictLabel: '场内机动车驾驶', name: '装载机', key: 'loadSelected', numKey: 'loadNum', num: '' },
    { dictLabel: '制冷作业', name: '制冷工', key: 'refrigerationSelected', numKey: 'refrigerationNum', num: '' },
    { dictLabel: '登高架设', name: '架设工', key: 'setUpSelected', numKey: 'setUpNum', num: '' }
])

const resData = ref({})

const jinduFormData = (state) => {
    let stateValue = state + ''
    // 订单状态 0未审核  1审核通过  2审核驳回  3进行中  4已完成
    let msg = '--'
    switch (stateValue) {
        case '0':
            msg = '未审核'
            break;
        case '1':
            msg = '审核通过'
            break;
        case '2':
            msg = '审核驳回'
            break;
        case '3':
            msg = '进行中'
            break;
        case '4':
            msg = '已完成'
            break;
        default:
            break;
    }
    return msg;

}
const open = async (data) => {
    console.log(data.id)
    dialogVisible.value = true;
    const result = await getOrderOneInfo({ id: data.id })
    resData.value = Object.assign({}, result.data)
}

const selectDictDataUserListFun = async (type) => {
    const result = await selectDictDataUserList({ type })
    let checkList = []
    if (type == 1 && resData.value.potentialChoose) {
        checkList = resData.value.potentialChoose.split(',')
    } else if (type == 2 && resData.value.measuresChoose) {
        checkList = resData.value.measuresChoose.split(',')
    } else if (type == 3 && resData.value.protectionChoose) {
        checkList = resData.value.protectionChoose.split(',')
    } else if (type == 4) {// 特殊
        specialOpen();
        return;
    }
    result.data.forEach(e => {
        console.log(e.dictCode);

        if (checkList.indexOf(e.dictCode + '') !== -1) {
            e.checked = true;
        }
    });
    gridData.value = result.data;
    innerVisible.value = true
}

const objectSpanMethod = ({
    row,
    column,
    rowIndex,
    columnIndex,
}) => {
    console.log("==================进来啦");
    console.log(rowIndex);
    
    if (columnIndex === 0) {

        if (rowIndex === 0) {
            return {
                rowspan: 2,
                colspan: 1,
            }
        }else if(rowIndex === 1) {
            return {
                rowspan: 0,
                colspan: 1
            }
        }else if (rowIndex === 3) {
            return {
                rowspan: 3,
                colspan: 1,
            }
        }else if (rowIndex === 4) {
            return {
                rowspan: 0,
                colspan: 1,
            }
        }else if (rowIndex === 5) {
            return {
                rowspan: 0,
                colspan: 1,
            }
        }else if (rowIndex === 6) {
            return {
                rowspan: 2,
                colspan: 1,
            }
        }else if (rowIndex === 7) {
            return {
                rowspan: 0,
                colspan: 1,
            }
        }
    }
}

const specialOpen = async () => {
    SpecialInnerVisible.value = true;
    const result = await getOrderOneInfoByMaintenanceNew({ id: resData.value.id })

    specialGridData.value.forEach((item) => {
        item.checked = (result.data[item.key] == 1) ? true : false;
        item.num = result.data[item.numKey];
    })

    setTimeout(() => {
        if (result.data.img) {
            srcList.value = result.data.img.split(',');
            console.log(srcList.value);
        }
    }, 100);

}
// 暴露 open 方法，使父组件可以调用
defineExpose({
    open
});
</script>